import React from 'react';
import { Link } from 'react-router-dom';
import styles from './abono.module.css';

import imagemAbono1 from './img/abono1.jpeg';
import imagemAbono2 from './img/abono2.jpg';

function AbonoSalarialBlog() {
  return (
    <div className={styles.paginaMateria}>
      <div className={styles.containerInterno}>
        
        <Link to="/blog" className={styles.btnVoltar}>
          &larr; Voltar para o Portal
        </Link>

        <header className={styles.cabecalhoMateria}>
          <span className={styles.tagMateria}>Atualização Trabalhista</span>
          <h1>Abono Salarial PIS/PASEP 2026: Novas Regras, Calendário e Diretrizes</h1>
          <p className={styles.subtitulo}>Uma análise detalhada sobre os critérios de elegibilidade, o novo cronograma de pagamentos e os impactos das recentes atualizações normativas no benefício.</p>
          <span className={styles.dataPublicacao}>Publicado em 28 de Março de 2026</span>
        </header>

        <div className={styles.imagemDestaque}>
          <img src={imagemAbono1} alt="Profissionais consultando calendário de benefícios trabalhistas" />
        </div>

        <article className={styles.conteudoTexto}>
          <p>
            O Abono Salarial do PIS/PASEP é um benefício constitucional, frequentemente tratado como um décimo quarto salário, destinado aos trabalhadores de baixa renda do setor público e privado. Sua finalidade precípua é promover a integração do empregado no desenvolvimento das empresas e proporcionar um complemento de renda fundamental para o fomento da economia nacional.
          </p>
          
          <p>
            Para o exercício de 2026, cujo ano-base de apuração é 2024, os órgãos governamentais implementaram atualizações significativas no processamento das informações e na unificação dos calendários. A principal mudança consolida o eSocial como fonte primária e essencial para a verificação de elegibilidade, exigindo das empresas um rigor extremo e tempestividade na transmissão de dados das folhas de pagamento.
          </p>
          
          <h2>Critérios de Elegibilidade e Impactos Corporativos</h2>
          <p>
            A concessão do abono salarial demanda o cumprimento cumulativo de quatro requisitos estabelecidos em lei. Primeiramente, o trabalhador deve estar inscrito no PIS ou no PASEP há pelo menos cinco anos completos. Adicionalmente, exige-se o exercício de atividade remunerada para Pessoa Jurídica por, no mínimo, 30 dias no ano-base, consecutivos ou não.
          </p>
          
          <p>
            Do ponto de vista financeiro, a remuneração mensal média do profissional não pode ter ultrapassado o limite de dois salários mínimos nacionais vigentes à época. Por fim, é imprescindível que os dados laborais e remuneratórios tenham sido reportados corretamente pelo empregador na Relação Anual de Informações Sociais (RAIS) ou nos eventos do eSocial. A omissão ou envio incorreto destas informações bloqueia a liberação dos valores.
          </p>
          
          <p>
            Essa dependência informacional gera impactos diretos nas rotinas corporativas. Aos empregadores, recai a responsabilidade legal de auditar minuciosamente as transmissões, prevenindo passivos trabalhistas e eventuais ações indenizatórias movidas por colaboradores que tiveram seus benefícios negados por inconsistências patronais.
          </p>

          <img src={imagemAbono2} alt="Análise de dados no eSocial e auditoria de departamento pessoal" className={styles.imagemCorpo} />

          <h2>Calendário de Pagamentos e Orientações Essenciais</h2>
          <p>
            O cronograma de pagamentos para 2026 foi estruturado visando otimizar o fluxo de repasses e evitar o congestionamento das instituições financeiras. Os depósitos tiveram início oficial em 15 de fevereiro para os beneficiários nascidos no mês de janeiro e seguirão um cronograma escalonado. O pagamento é realizado pela Caixa Econômica Federal (iniciativa privada) seguindo o mês de nascimento, e pelo Banco do Brasil (servidores públicos) acompanhando o dígito final do número de inscrição.
          </p>
          
          <p>
            Diante deste cenário normativo, é imperativo que os setores de Departamento Pessoal adotem uma postura proativa, orientando os colaboradores a consultarem sua elegibilidade através dos canais oficiais do Ministério do Trabalho, como o aplicativo Carteira de Trabalho Digital (CTPS Digital) ou o portal Gov.br.
          </p>
          
          <p>
            A antecipação na identificação de divergências cadastrais permite a retificação ágil por parte da empresa, garantindo o pleno cumprimento dos direitos dos trabalhadores e atestando o compromisso da organização com a conformidade legal e a responsabilidade social.
          </p>
        </article>

      </div>
    </div>
  );
}

export default AbonoSalarialBlog;